import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Teams\"}}\n\n\n\n\n{{outlet}}\n",{ moduleName: "seshy/templates/authenticated/teams/index.hbs" })